import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateParentForm from "../../forms/CreateOrUpdateParentForm";
import { ParentGuardianResponseDto } from "../../shared/dtos/parentGuardian/ParentGuardianResponseDto";

interface UpdateParentModalProps {
  open: boolean;
  onClose: () => void;
  parent: ParentGuardianResponseDto | null;
  loading: boolean;
  error: string | null;
}

const UpdateParentModal: React.FC<UpdateParentModalProps> = ({
  open,
  onClose,
  parent,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit: ${parent?.firstName || ""} ${parent?.lastName || ""}`}
    width="md"
    loading={loading}
  >
    <CreateOrUpdateParentForm
      isEditing={true}
      parent={parent}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateParentModal;
